import Vue from "vue";
import App from "./App";
import router from "./router";
import VueI18n from "vue-i18n";
import ElementUI from "element-ui";
import { createPinia, PiniaVuePlugin } from "pinia";
import "@/assets/style/element/index.css";
import piniaPluginPersist from "pinia-plugin-persist";
import "@/assets/style/common.css";
import "@/assets/style/element.less";
import "@/assets/icon/iconfont.css";
import "@/assets/style/default.less";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import en from "./locales/en.js";
import cn from "./locales/cn.js";
import fcn from "./locales/fcn.js";
import tableHeight from "@/directive";
import { VueJsonp } from "vue-jsonp";
import * as VueGoogleMaps from "vue2-google-maps";
import "@/components";
import DevicePixelRatio from "@/utils/DevicePixelRatio.js";
import { useCounterStore } from "@/store/index";
import Print from "vue-print-nb";
import contentmenu from "v-contextmenu";
// import "amfe-flexible";
import { judgeClient } from "@/utils/utils";

import "v-contextmenu/dist/index.css";

const bodyScale = () => {
  var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
  var scale = devicewidth / 1920; // 分母——设计稿的尺寸
  document.body.style.zoom = scale; //放大缩小相应倍数
};

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDw39815-AdsxXv2igHemBMy99JsLNt1U0",
    libraries: "places" // 根据你的需求添加其他库
  }
});
Vue.use(VueJsonp);
Vue.use(ElementUI, { locale: zhLocale });
Vue.use(VueI18n);
Vue.use(PiniaVuePlugin);
Vue.use(ElementUI);
Vue.use(Print);
Vue.use(contentmenu);

// 表格自适应指令
Vue.use(tableHeight);

const pinia = createPinia();

pinia.use(piniaPluginPersist);

Vue.use(pinia);
let store = useCounterStore();
if (localStorage.getItem("token")) {
  store.addMenu();
}

// 注册全局方法
Vue.prototype.$displayObjectName = function(obj) {
  if (obj.hasOwnProperty("name") && obj.name !== null && obj.name !== "") {
    return obj.name;
  } else {
    return obj.name_en;
  }
};

export const i18n = new VueI18n({
  locale: "en", // 默认语言
  messages: {
    en, // 英文翻译文本
    cn, // 中文翻译文本
    fcn // 繁体中文翻译文本
  }
});

// 屏幕适配
// if (judgeClient() == "iOS") {
// new DevicePixelRatio().init();
// bodyScale();
// }
console.log(judgeClient());

Vue.directive("auth", {
  // 只调用一次，指令第一次绑定到元素时调用……
  inserted: (el, node) => {
    const list = router.currentRoute.meta.menu;
    const { value } = node;
    if (store.userInfo.is_boss == 0 && list.indexOf(value) === -1) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
});

new Vue({
  i18n,
  router,
  pinia,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js